//messages.js
export default {
    machine_id: "Machine Id",
    line_id: "Line Id",
    machine_name: "Machine Name",
    short_code: "Short Code",
    category_id: "Category Id",
    status_id: "Status Id",
    edit_machine: "Edit Machine",
    add_machine: "Add Machine",
    delete_machine: "Delete Machine",
    machines: "Machines",
    delete_machine_confirm: "This action is not reversible!",
    modify_machine: "Modify Machine",
};
